import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 1.75rem;
  width: 90%;
  max-width: 520px;
  text-align: center;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.35);
`;

const Title = styled.h3`
  font-size: 1.2rem;
  font-weight: 800;
  margin-bottom: 0.6rem;
  color: #111827;
`;

const Text = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
  margin-bottom: 1.25rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const PrimaryLink = styled(Link)`
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #ffffff;
  padding: 0.6rem 1.4rem;
  border-radius: 999px;
  font-weight: 600;
  text-decoration: none;
`;

const SecondaryLink = styled(Link)`
  border: 1px solid #e5e7eb;
  color: #374151;
  padding: 0.6rem 1.2rem;
  border-radius: 999px;
  font-weight: 600;
  text-decoration: none;
`;

const AccessGateModal = ({ type, onClose }) => {
  if (!type) return null;

  const isAuth = type === 'auth';
  const title = isAuth ? 'Ücretsiz Kayıt ol' : 'Premium Pass Gerekli';
  const message = isAuth
    ? 'Kariyer Hedefinde İlerlemeye 1 Adım Kaldı'
    : 'Bu aracı kullanmak için Premium Pass satın almalısın.';

  return (
    <Overlay onClick={onClose}>
      <Card onClick={(e) => e.stopPropagation()}>
        <Title>{title}</Title>
        <Text>{message}</Text>
        <ButtonRow>
          {isAuth ? (
            <>
              <PrimaryLink to="/register">Kayıt Ol</PrimaryLink>
              <SecondaryLink to="/login">Giriş Yap</SecondaryLink>
            </>
          ) : (
            <>
              <PrimaryLink to="/pricing">Premium Pass Al</PrimaryLink>
              <SecondaryLink to="/dashboard">Profilime Dön</SecondaryLink>
            </>
          )}
        </ButtonRow>
      </Card>
    </Overlay>
  );
};

export default AccessGateModal;
